const STORAGE_KEY = 'colorphoto-gallery'
const MAX_ITEMS = 20
/** זיהוי פריט שמירה אוטומטית (לא נספר כציור משתמש) */
export const GALLERY_AUTOSAVE_ID = 'gallery-autosave'
const AUTOSAVE_ID = GALLERY_AUTOSAVE_ID

export function getGallery() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return []
    const list = JSON.parse(raw)
    return Array.isArray(list) ? list : []
  } catch {
    return []
  }
}

function saveGallery(list) {
  try {
    if (typeof localStorage === 'undefined') throw new Error('אחסון לא זמין (גלריה לא נתמכת בדפדפן זה)')
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list))
  } catch (e) {
    if (e.name === 'QuotaExceededError') throw new Error('אין מקום בשמירה - נסו למחוק פריטים מהגלריה')
    if (e.name === 'SecurityError') throw new Error('אחסון חסום (למשל מצב פרטי). שמרו את התמונה לקובץ במקום.')
    throw e
  }
}

export function addToGallery(dataUrl, name) {
  const list = getGallery()
  if (list.length >= MAX_ITEMS) throw new Error(`הגלריה מלאה (עד ${MAX_ITEMS} תמונות)`)
  const item = {
    id: `gallery-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`,
    dataUrl,
    name: name || `צביעה ${list.length + 1}`,
    createdAt: Date.now(),
  }
  list.unshift(item)
  saveGallery(list)
  return item
}

/**
 * Upsert a fixed "autosave" item so we don't spam the gallery.
 * Keeps it at the top of the list and does not increase item count.
 */
export function upsertAutosave(dataUrl) {
  const list = getGallery()
  const existingIdx = list.findIndex((i) => i.id === AUTOSAVE_ID)
  const item = {
    id: AUTOSAVE_ID,
    dataUrl,
    name: 'שמירה אוטומטית',
    createdAt: Date.now(),
  }
  if (existingIdx >= 0) {
    list.splice(existingIdx, 1)
    list.unshift(item)
    saveGallery(list)
    return item
  }
  if (list.length >= MAX_ITEMS) {
    // Drop the oldest item to make room for autosave.
    list.pop()
  }
  list.unshift(item)
  saveGallery(list)
  return item
}

export function removeFromGallery(id) {
  const list = getGallery().filter((item) => item.id !== id)
  saveGallery(list)
}

export function getGalleryItem(id) {
  return getGallery().find((item) => item.id === id) || null
}
